import React from 'react';
import Navigation from './Navigation/Navigation';
import { useNavbar } from '../context/NavbarContext';
import { StyledLayoutContainer, StyledMainContent, StyledContentWrapper } from './Layout.styles';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isCollapsed } = useNavbar();

  return (
    <StyledLayoutContainer>
      <Navigation />
      <StyledMainContent $isCollapsed={isCollapsed}>
        <StyledContentWrapper>{children}</StyledContentWrapper>
      </StyledMainContent>
    </StyledLayoutContainer>
  );
};

export default Layout;
